(function() {
    'use strict';

    angular
        .module('sgnmrApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('entity', {
            abstract: true,
            parent: 'private'
        });
    }
})();
